import React from 'react'

import useText from '../../../common/hooks/useText'
import {
    SubscriptionCardLayout,
    SubscriptionMarketingFeature,
} from '../subscription-card-layout/subscription-card-layout'
import { formatToCurrencyString } from '../../../common/services/utilsService'
import { useLocalizationContext } from '../../../common/components/localization-provider'

export type BasicSubscriptionCardWidgetProps = {
    marketingFeatures: SubscriptionMarketingFeature[]
    currency: string
}

export function BasicSubscriptionCardWidget({ marketingFeatures, currency }: BasicSubscriptionCardWidgetProps) {
    const text = useText()
    const { locale } = useLocalizationContext()

    const basicMarketingFeatures = marketingFeatures
        .filter((feature) => feature.label !== 'lblMarketingFeatureHistory')
        .map((feature) => ({
            ...feature,
            isActive: feature.productLevel === 0,
        }))

    return (
        <SubscriptionCardLayout
            testId="subscription-basic-card"
            title={text('lblBasicProductName')}
            description={text('lblBasicProductDescription')}
            price={formatToCurrencyString(currency, 0, locale)}
            priceDetailLines={[text('lblFreeForCAChargers')]}
            marketingFeatures={basicMarketingFeatures}
            footer={<p className="text-xl m-0">{text('lblYourCurrentPlan')}</p>}
        />
    )
}
